import extend from 'extend';
import config from './config';

const LAN = {
    APPName: ['任务中心', '任务中心'],

    nui: {
        exit: ['再按一次返回键退出应用', 'Press the return key again to exit the application'],
        browser: ['您的浏览器版本过低，请使用Edge或其他高版本第三方浏览器访问', 'Your browser version is too low. Please use edge or other advanced third-party browser to visit'],
        loading: ['加载中，请稍后', 'Loading'],

        scroll: {
            pullUpNotice: ['上拉加载更多', 'Pull up loading more'],
            pullUpEndNotice: ['我也是有底线的~', 'No more']
        },

        dateSelect: {
            title: ['日期选择', 'Date Selector'],
            monthTitle: ['月份选择', 'Month Selector'],
            year: ['年', '-'],
            month: ['月', '-'],
            monthen: ['月', ''],
            day: ['日', ''],
            pleaseSelectRange: ['请选择完整的区间', 'Please select range'],
            single: ['单日', 'Single Day'],
            multiple: ['多日', 'Multiple Days'],
            weekTitles: {
                0: ['日', 'Sun'],
                1: ['一', 'Mon'],
                2: ['二', 'Tue'],
                3: ['三', 'Web'],
                4: ['四', 'Thu'],
                5: ['五', 'Fri'],
                6: ['六', 'Sat']
            }
        },

        page: {
            prev: ['上一页', 'Prev'],
            next: ['下一页', 'Next']
        },

        upload: {
            penddingNotice: ['上传中，请稍后', 'Uploding'],
            uploadFailed: ['上传失败', '上传失败'],
            fileError: ['文件类型/格式错误', 'File type or format error'],
            fileSizeTooSmall: ['您上传的文件内容过小，请重新上传', 'The file you uploaded is too small, please upload again'],
            fileSizeTooLarge: ['您上传的文件内容过大，最大可上传|SIZE|，请重新上传', 'The file you uploaded is too large, up to |SIZE|, please upload again'],
            all: ['所有', 'all'],
            warn: ['请选择|EXT|类型并且小于|SIZE|的文件，最多可上传|COUNT|个文件', 'Please upload |EXT| suffix and less than |SIZE| files, up to |COUNT|']
        },

        dateTypeSelect: {
            week: ['本周', 'Week'],
            month: ['本月', 'Month'],
            year: ['本年', 'Year'],
            more: ['更多', 'More']
        },

        selectAddress: {
            noLevelData: ['该类别下暂无数据', 'No data']
        },

        selectAddress: {
            noLevelData: ['该类别下暂无数据', 'No data'],
            province: ['省份', 'Province'],
            city: ['城市', 'City'],
            area: ['区/县', 'Area']
        },

        common: {
            timeout: ['正在努力加载中，请稍后~', 'Trying to load, please wait~'],
            timeoutError: ['请求超时，请调整网络重新尝试', 'Request timed out, please adjust the network to try again'],
            selected: ['已选择', 'Selected'],
            noSelected: ['您还未进行选择', 'No selected'],
            cancel: ['取消', 'Cancel'],
            ok: ['确定', 'OK'],
            pleaseEnterKeyword: ['请输入关键字', 'Please enter keyword'],
            pleaseEnter: ['请输入', 'Please enter'],
            pleaseSelect: ['请选择', 'Please select'],
            noData: ['还没有相关记录哦', 'No data'],
            emptyData: ['暂无相关记录', 'No data'],
            complete: ['完成', 'Complete'],
            save: ['保存', 'Save'],
            submit: ['提交', 'Submit'],
            add: ['新增', 'Add'],
            delete: ['删除', 'Delete'],
            edit: ['编辑', 'Edit'],
            yes: ['是', 'Yes'],
            no: ['否', 'No'],
            logout: ['退出登陆', 'Logout']
        }
    }
};

let LF = {
    exportLanguage: function () {
        var languageIndex = this.getLanguage(),
            languageCopy = extend(true, {}, LAN);

        return this.parseLanguage(languageCopy, languageIndex);
    },
    parseLanguageBySequence: function (lanSequence) {
        var languageIndex = this.getLanguage();

        lanSequence = lanSequence.split('|');
        var lanArr = LAN;
        for (var i = 0; i < lanSequence.length; i++) {
            lanArr = lanArr[lanSequence[i]];
        }
        return Array.isArray(lanArr) ? lanArr[languageIndex] : lanArr;
    },
    parseLanguage: function (language, index) {
        for (let i in language) {
            if (language.hasOwnProperty(i)) {
                if (Array.isArray(language[i])) {
                    language[i] = language[i][index];
                } else {
                    this.parseLanguage(language[i], index);
                }
            }
        }

        return language;
    },
    getLanguage: function () {
        var cache = localStorage.getItem(config.PREFIX + 'LANGUAGE');
        return isNaN(parseInt(cache)) ? 0 : cache;
    },
    setLanguage: function (index) {
        localStorage.setItem(config.PREFIX + 'LANGUAGE', index);
    }
};
export default {
    LAN,
    LF,
    language: LF.exportLanguage()
};
